import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';

export const useIsPromanBusinessUnit = (): boolean => {
  const { isProman } = useBusinessUnitContext();
  return isProman;
};
